module.exports = __webpack_public_path__ + "assets/events_toc_black.8630d18d.svg";